/**
 * Retrieves palette data and passes it to a given callback function.
 *
 * This function extracts palette data from a global `window.clientApiData` object
 * and then provides this data to the `eventName` callback function.
 *
 * @param eventName - A callback function that receives the palette data.
 * @returns The result of the `eventName` callback.
 */
export const getPaletteData = (eventName: any) => {
  const palette = {
    ...window.clientApiData.paletteData,
  };
  return eventName(palette);
};
